import { render, staticRenderFns } from "./VoteDetail.vue?vue&type=template&id=412e6c4b&"
import script from "./VoteDetail.vue?vue&type=script&lang=js&"
export * from "./VoteDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports